import gql from 'graphql-tag';

export default gql`
mutation sendFeedbackEmail($to: String!, $subject: String!, $text: String!, $html: String!) {
  sendEmail(object: {to: $to, subject: $subject, text: $text, html: $html}) {
    info
  }
}
`;
